import { useSelector } from '@xstate/react';
import { useMsaasListingSearchRef } from '../../marketSelectors';
import type { MarketplaceDetail } from '../types';

const TextBox = ({ label, color }: { label: string; color?: 'blue' | 'grey' }) => {
  const colorToUse = color || 'blue';
  return (
    <div
      className={`min-w-0 w-full border-b border-grey-900 px-1 py-3 [overflow-wrap:anywhere] ${colorToUse === 'blue' ? 'text-content-secondary' : 'text-content-primary'}`}
    >
      <p
        className={
          colorToUse === 'blue'
            ? 'text-sm font-semibold leading-5'
            : 'text-[1rem] font-normal leading-6'
        }
      >
        {label || '—'}
      </p>
    </div>
  );
};

export const ShiftDistribution = () => {
  const { msaasListingsSearchRef } = useMsaasListingSearchRef();
  const context = useSelector(msaasListingsSearchRef, (state) => state?.context);
  if (!msaasListingsSearchRef || !context) return null;
  const { listing } = context;
  const SHIFT_DIST_FIELDS = [
    'Weekday',
    'numDayShifts',
    'numEveShifts',
    'numNightShifts',
    'Weekend',
    'numOfWeDayShifts',
    'numOfWeEveShifts',
    'numOfWeNightShifts',
    'Holiday',
    'numHolDayShifts',
    'numHolEveShifts',
    'numHolNightShifts',
  ];

  const noShiftsSpecified = SHIFT_DIST_FIELDS.every(
    (field) => !listing?.detail?.[field as keyof MarketplaceDetail]
  );

  return (
    <div>
      {noShiftsSpecified ? (
        <>
          <div className="text-xl font-bold leading-snug mb-4 mt-6">Shift Distribution</div>
          <p className="text-[1rem] leading-6 text-content-secondary">
            No shift distribution specified
          </p>
        </>
      ) : (
        <div>
          <div className="text-xl font-bold leading-snug mb-4 mt-6 text-left">
            Shift Distribution
          </div>

          <div className="mb-4 grid grid-cols-4 flex-col gap-x-2 text-grey-100">
            <div />
            <TextBox label={'Day'} />
            <TextBox label={'Evening'} />
            <TextBox label={'Night'} />
            {SHIFT_DIST_FIELDS.map((field) =>
              field === 'Weekday' || field === 'Weekend' || field === 'Holiday' ? (
                <TextBox key={field} label={field} />
              ) : (
                <TextBox
                  key={field}
                  color="grey"
                  label={listing?.detail?.[field as keyof MarketplaceDetail]?.toString() || ''}
                />
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};
